/**
 * Класс для управления фильтрацией результатов поиска.
 * Позволяет фильтровать результаты по типу и переключаться между различными секциями.
 */
export class SearchFilters {
  private container: HTMLElement
  private sections: Map<string, HTMLElement> = new Map()

  /**
   * Создает экземпляр SearchFilters.
   * @param {HTMLElement} container - HTML элемент-контейнер с фильтрами и результатами поиска
   */
  constructor(container: HTMLElement) {
    this.container = container

    this.init()
  }

  /**
   * Инициализирует фильтры, читает секции результатов и устанавливает обработчики событий.
   * @private
   */
  private init() {
    this.readFilteredSections()
    this.container.addEventListener('click', this.onFilterClick)
  }

  /**
   * Читает и сохраняет все секции результатов поиска из DOM.
   * Секции определяются атрибутом data-results-section.
   * @private
   */
  private readFilteredSections() {
    const sectionElements = this.container.querySelectorAll<HTMLElement>(
      '[data-results-section]'
    )
    sectionElements.forEach((section) => {
      const sectionName = section.dataset.resultsSection
      if (sectionName) {
        this.sections.set(sectionName, section)
      }
    })
  }

  /**
   * Обрабатывает клик по кнопке фильтра.
   * Обновляет активный фильтр и применяет фильтрацию к секциям результатов.
   * @param {MouseEvent} event - Событие клика
   * @private
   */
  private onFilterClick = (event: Event) => {
    const target = event.target as HTMLElement
    const filterBtn = target.closest<HTMLElement>('[data-type]')

    if (!filterBtn) return

    event.preventDefault()
    this.resetActiveFilterBtn()
    filterBtn.classList.add('is-active')
    const selectedType = filterBtn.dataset.type
    this.updateFilterSelection(selectedType || null)
  }

  /**
   * Обновляет видимость секций результатов на основе выбранного фильтра.
   * @param {string | null} selectedType - Выбранный тип фильтра или null для отображения всех результатов
   * @private
   */
  private updateFilterSelection(selectedType: string | null) {
    const isAll = selectedType === null || selectedType === 'all'

    this.sections.forEach((section, type) => {
      section.classList.toggle('is-hidden', !isAll && type !== selectedType)
    })
  }

  /**
   * Сбрасывает активное состояние со всех кнопок фильтров.
   * @private
   */
  private resetActiveFilterBtn() {
    const filterBtns = this.container.querySelectorAll<HTMLElement>(
      '[data-type].is-active'
    )
    filterBtns.forEach((btn) => btn.classList.remove('is-active'))
  }
}
